import React from "react";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import styled from "styled-components";

interface RankingCellProps {
  rank: number;
}

const RankCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f1f3f4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: #5f6368;
`;

const TrophyColors: { [key: number]: string } = {
  1: "#FFD700", // Gold
  2: "#C0C0C0", // Silver
  3: "#CD7F32", // Bronze
};

export const RankingCell: React.FC<RankingCellProps> = ({ rank }) => {
  if (rank >= 1 && rank <= 3) {
    return <EmojiEventsIcon style={{ color: TrophyColors[rank] }} />;
  }

  return <RankCircle>{rank}</RankCircle>;
};